// Deployment-configurable feature flags.
//
// Flags must NOT be read as `process.env.X === 'true'`: at build time the
// value is a #{...}# release-pipeline token (never 'true'), so the minifier
// constant-folds that comparison to `false` and deletes the token from the
// bundle — the release pipeline can then never enable the flag. Reading
// through window.__ENV__ (populated by public/config.js, where the release
// pipeline replaces the tokens post-build) keeps the decision at runtime.
//
// In development config.js still contains raw placeholders, so we fall back
// to the build-time values from .env.development.

const PLACEHOLDER = /^#\{.+\}#$/

const isSet = value => value != null && value !== '' && !PLACEHOLDER.test(value)

// Static `process.env.X` member access is required for CRA's DefinePlugin
// to inline the values; read lazily so tests can vary process.env.
const buildTimeValues = () => ({
  REACT_APP_CARTO_API_KEY: process.env.REACT_APP_CARTO_API_KEY,
  REACT_APP_ENABLE_AAD_LOGIN: process.env.REACT_APP_ENABLE_AAD_LOGIN,
  REACT_APP_DISABLE_PASSWORD_LOGIN:
    process.env.REACT_APP_DISABLE_PASSWORD_LOGIN,
})

export function getEnvValue(name) {
  const runtime = (window.__ENV__ || {})[name]
  const value = isSet(runtime) ? runtime : buildTimeValues()[name]
  return isSet(value) ? value : undefined
}

export function getEnvFlag(name) {
  return getEnvValue(name) === 'true'
}
